/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React from 'react';
import { Container } from 'reactstrap';
import * as default_data from '../config.js'
import { sanitizeHtml } from '../Utils/text_functions';
import { Button, Checkbox, Dialog, DialogActions, Stack } from '@mui/material';
import { ScrollableDialogContent } from '../Components/ScrollableDialogContent.js';

const Terms = ({ acceptedTerms, setAcceptedTerms }) => {
  const [showTerms, setShowTerms] = React.useState(false);

  return (
    <>
      <Stack spacing={2} direction={'row'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
        <Checkbox 
          checked={acceptedTerms} 
          disableRipple
          sx={{ 
            padding: 0,
            '& .MuiSvgIcon-root': {
              color: '#BBBBBB',
            }
          }}
          onChange={() => setAcceptedTerms(!acceptedTerms)} 
        />
        <div style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
          flexWrap: 'wrap' // Allow wrapping
        }}>
          I have read and agree to the
          <div onClick={() => setShowTerms(!showTerms)} style={{ cursor: 'pointer', textDecoration: 'underline', marginLeft: '4px', marginRight: '4px' }}>Terms and Conditions</div>
          (required)
        </div>
      </Stack>
      <Dialog
        open={showTerms}
        onClose={() => setShowTerms(false)}
        fullWidth
        maxWidth="md"
      >
        <ScrollableDialogContent>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(default_data.default_terms_text) }}></div>
        </ScrollableDialogContent>
        <DialogActions>
          <Button onClick={() => setShowTerms(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
);
};

export default Terms;
